import { RootState } from './index';

export const selectTrialPeriod = ({ trialPeriod }: RootState) => trialPeriod;

export default { selectTrialPeriod };
